import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";

const SECTIONS = [
  {
    title: "Information We Collect",
    body: "Through the enquiry form on this website, we collect the information you choose to provide: full name, email address, phone number (where applicable), company or organisation, enquiry type and your message. We also process verification data (a one-time code) solely to confirm ownership of the email address and, where required, the phone number supplied.",
  },
  {
    title: "Purpose of Collection",
    body: "Information is collected to respond to enquiries, assess strategic partnership or business opportunities, and to maintain an accurate record of communications with Gopi Gadhvi Group.",
  },
  {
    title: "OTP Verification",
    body: "One-time verification codes are generated server-side, stored only as a secure hash, and expire automatically after a short window. Codes are never logged in plain text and cannot be reused once verified.",
  },
  {
    title: "Contact and Enquiry Records",
    body: "Submitted enquiries are stored securely in our database, including a timestamp, verification status and the page from which the enquiry originated, to help us respond appropriately.",
  },
  {
    title: "Cookies and Analytics",
    body: "This website may use essential cookies and privacy-conscious analytics to understand aggregate usage patterns and improve the experience. No sensitive personal data is sold or shared for advertising purposes.",
  },
  {
    title: "Third-Party Service Providers",
    body: "We may rely on third-party providers for email delivery and, in future, SMS delivery, strictly to facilitate verification and notifications. These providers process data only as required to deliver their service.",
  },
  {
    title: "Data Retention",
    body: "Enquiry records are retained only as long as reasonably necessary to address the enquiry and for legitimate record-keeping, after which they may be archived or deleted.",
  },
  {
    title: "Security",
    body: "We apply reasonable technical safeguards, including hashed verification codes, rate limiting and server-side validation, to protect information from unauthorised access.",
  },
  {
    title: "Your Rights",
    body: "You may request details of the information we hold about you, request correction, or request deletion, subject to legitimate record-keeping requirements, by contacting us through the enquiry form.",
  },
  {
    title: "External Links",
    body: "This website links to independently operated venture websites and social platforms. We are not responsible for the privacy practices of those external destinations.",
  },
  {
    title: "Policy Updates",
    body: "This policy may be updated from time to time to reflect changes in our practices or applicable law. The date of the most recent revision will be reflected on this page once finalised.",
  },
];

const Privacy = () => {
  return (
    <div data-testid="page-privacy">
      <SEO title="Privacy Policy" description="How Gopi Gadhvi Group collects, uses and protects information submitted through this website." path="/privacy" />
      <PageHero eyebrow="Legal" heading="Privacy Policy" minHeight="32vh" />

      <section className="relative page-shell pb-28">
        <div className="editorial-col mx-auto space-y-10">
          <p className="text-small" data-testid="privacy-legal-review-note">
            This page is marked for professional legal review before final publication and does not
            constitute legal advice.
          </p>
          {SECTIONS.map((s) => (
            <div key={s.title}>
              <h2 className="text-h4 mb-3">{s.title}</h2>
              <p className="text-body text-justify">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Privacy;
